import React from 'react';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';

import Profile from '../../components/Profile/Profile';

import styles from './profileNav.css';

function ProfileNav({ data, isToggleOn }) {
	return (
		<div className={styles.content}>
	    <CSSTransitionGroup
	      transitionName={styles}
	      transitionEnterTimeout={400}
	      transitionLeaveTimeout={400}>
	      {isToggleOn ? <Profile data={data} /> : null }
	    </CSSTransitionGroup>
	  </div>
	);
}

export default ProfileNav;


// WEBPACK FOOTER //
// ./src/components/ProfileNav/ProfileNav.js